// src/App.js
import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Link,
  useLocation,
} from "react-router-dom";

import GuidePage from "./GuidePage";
import FullDemoPage from "./FullDemoPage";
import ChatPage from "./ChatPage";
import GoogleCaptcha from "./components/Captcha/GoogleCaptcha";
import { NAVY } from "./colors"; // added for consistent color usage

// Composant onglet actif
function NavTab({ to, label }) {
  const location = useLocation();
  const active = location.pathname === to;

  // improved pill-like styles with hover & active visuals
  return (
    <Link
      to={to}
      role="button"
      style={{
        position: "relative",
        padding: "10px 18px",
        borderRadius: 999,
        textDecoration: "none",
        fontWeight: 800,
        fontSize: 15,
        color: active ? NAVY : "rgba(255,255,255,0.95)",
        background: active ? "rgba(255,255,255,1)" : "transparent",
        transition: "transform 160ms ease, box-shadow 160ms ease, background 160ms ease, color 160ms ease",
        boxShadow: active ? `0 8px 22px rgba(47,78,139,0.14)` : "none",
        transform: active ? "translateY(-4px)" : "none",
        border: "1px solid rgba(255,255,255,0.06)",
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        cursor: "pointer",
        WebkitTapHighlightColor: "transparent",
      }}
      onMouseEnter={(e) => {
        if (!active) e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.08)";
      }}
      onMouseLeave={(e) => {
        if (!active) e.currentTarget.style.boxShadow = "none";
      }}
    >
      <span style={{ pointerEvents: "none" }}>{label}</span>

      {/* subtle active indicator */}
      <span
        aria-hidden
        style={{
          position: "absolute",
          bottom: -8,
          left: "50%",
          transform: "translateX(-50%)",
          width: active ? 40 : 0,
          height: 4,
          borderRadius: 4,
          background: active ? NAVY : "transparent",
          transition: "width 160ms ease, background 160ms ease",
        }}
      />
    </Link>
  );
}

export default function App() {
  const [showAppCaptcha, setShowAppCaptcha] = React.useState(true);

  return (
    <>
      {/* CAPTCHA (affiché en premier) */}
      {showAppCaptcha && (
        <GoogleCaptcha
          onSuccess={() => setShowAppCaptcha(false)}
          handleClose={() => {}}
        />
      )}

      {/* APP une fois captcha validé */}
      {!showAppCaptcha && (
        <BrowserRouter>
          {/* BARRE D'ONGLETS */}
          <nav
            style={{
              background: "linear-gradient(90deg, rgba(47,78,139,0.98), rgba(52,95,160,0.95))",
              padding: "12px 20px",
              display: "flex",
              justifyContent: "center",
              gap: "20px",
              alignItems: "center",
              borderBottom: "1px solid rgba(0,0,0,0.06)",
              boxShadow: "0 6px 20px rgba(20,35,64,0.06)",
              // centered max width with slight rounded corners to appear as a bar
              borderRadius: 12,
              margin: "14px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: 12,
                alignItems: "center",
                width: "100%",
                maxWidth: 1100,
                margin: "0 auto",
                justifyContent: "center",
                padding: "4px",
              }}
            >
              <NavTab to="/full-demo" label="Démo complète" />
              <NavTab to="/guide" label="Guide vidéo – Congés & Télétravail" />
              <NavTab to="/chat" label="Chat Conseiller juridique" />
            </div>
          </nav>

          {/* ROUTES */}
          <Routes>
            <Route path="/" element={<Navigate to="/full-demo" />} />
            <Route path="/guide" element={<GuidePage />} />
            <Route path="/full-demo" element={<FullDemoPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route
              path="*"
              element={<h1 style={{ padding: 50 }}>Page introuvable</h1>}
            />
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
}
